import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {ApiService} from './api.service';
import {Availibility} from './../models/availibility.model';

const routes = {
    comparator: '/dispo',
};

@Injectable({
    providedIn: 'root'
})
export class AvailibilityService {
    
    private _data: Availibility;
    availibilitySubject = new Subject<any>();
    
    constructor(private apiService: ApiService) {}

    getDisp(start: string, end: string, adults: number, enfants: number,idetab:number, agesEnfants: Array<any>, currency: string, tokenSearch: string, utmSource: string): Observable<Availibility> {
        let params = new HttpParams({
            fromObject: {
                adults: adults.toString(),
                enfants: enfants.toString(),
                curency: currency,
                start: start,
                idetab:idetab.toString(),
                end: end,
                nbRooms: "1",
                tokenSearch: tokenSearch,
                utmSource: utmSource,
            }
        });
        agesEnfants.forEach(v => {
            params = params.append('agesEnfants[]', v);
        });
        return this.apiService.get(routes.comparator, params)
            .pipe(map((response: any) => {
                this.availibilitySubject.next(response);
                if (response.error != undefined) {
                    return response;
                } else {
                    this._data = new Availibility(response);
                    return this._data;
                }
            }));
    }
    
    public getAvailibility(): Availibility {
        return this._data;
    }

}
